import React from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import { checkPermission } from '../../../common/guards/can';

const storePerformances = profileAttributes => profileAttributes['has-reward-outlet'] || profileAttributes['user-group'] !== 'staff';
const MyStore = (props) => {
  const {
    handleMenu,
    staffsOutletId,
    staffStorePerformances,
    userGroup
  } = props;
  return (
    <div className="nav-menu-links-list nav-menu-store">
      <h4>MY STORE</h4>
      <div className="header-underline" />
      <Link to={'/my-profile'} onClick={() => handleMenu()}>My profile</Link>
      { userGroup !== 'staff' && (
        <Link to={'/store-summary'} onClick={() => handleMenu()}>My store details</Link>
      )}
      { staffsOutletId !== 0 && userGroup === 'staff' && (
        <Link to={`/store-details/${staffsOutletId}`} onClick={() => handleMenu()}>My store details</Link>
      )}
      {checkPermission('view', 'objective_info,objective_performance', 'AND') &&
      staffStorePerformances && (
        <Link to={'/store-performances'} onClick={() => handleMenu()}>Store performance</Link>
      )}
      <Link to={'/outlet'} onClick={() => handleMenu()}>Add a store</Link>
      {checkPermission('view', 'web_app_messages') && (
        <Link to={'/my-messages'} onClick={() => handleMenu()}>My messages</Link>
      )}
      {checkPermission('handle', 'staff') && (
        <Link to={'/my-staff'} onClick={() => handleMenu()}>My staff</Link>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  staffStorePerformances: storePerformances(state.viewConfig.profile.attributes),
  staffsOutletId: state.viewConfig.profile.attributes['staff-member-of-outlet-id'],
  userGroup: state.viewConfig.profile.attributes['user-group']
});

export default connect(mapStateToProps)(MyStore);



// WEBPACK FOOTER //
// ./src/components/layout/user-navigation/navbar-items/my-store.jsx